export const unifyColors = {
  mainRed: '#f54e4e',
  mainTeal: '#338498',
  title: '#004d61',
  paragraph: '#004D61',
  mainLightTeal: '#5bd1d7',
  mainLightBlue: '#e1fbfd',
  white: '#ffffff',
  black: '#000000',
  darkBlue: '#042942',
  mainPurple: '#8c55c2',
  curiousBlue: '#2a87c8',
  mainGreen: '#2dca8c',
  mainYellow: '#ffc247',
  mainGrey: '#e8eef4',
  aquaBlue500: '#002942',
  type: {
    primary: '#2B6B7B',
    secondary: '#2B6B7B',
    tertiary: '#2B6B7B',
  },
};

export const unifyTeal = {
  50: '#DEF6F7',
  100: '#C8F0F2',
  200: '#ADE8EB',
  300: '#92E0E4',
  400: '#76D9DE',
  500: '#5BD1D7',
  600: '#4CAEB3',
  700: '#3D8B8F',
  800: '#2E696C',
  900: '#1E4648',
  950: '#122A2B',
};

export const unifyBlue = {
  50: '#CCDBDF',
  100: '#AAC4CA',
  200: '#80A6B0',
  300: '#558896',
  400: '#2B6B7B',
  500: '#004D61',
  600: '#004051',
  700: '#003341',
  800: '#002731',
  900: '#001A20',
  950: '#000F13',
};

export const unifyRed = {
  50: '#FDDCDC',
  100: '#FCC4C4',
  200: '#FAA6A6',
  300: '#F88989',
  400: '#F76C6C',
  500: '#F54E4E',
  600: '#CC4141',
  700: '#A33434',
  800: '#7B2727',
  900: '#521A1A',
  950: '#311010',
};

export const unifyPurple = {
  50: '#E8DDF3',
  100: '#D9C6EB',
  200: '#C5AAE0',
  300: '#B28ED6',
  400: '#9F71CC',
  500: '#8C55C2',
  600: '#7547A2',
  700: '#5D3981',
  800: '#462B61',
  900: '#2F1C41',
  950: '#1C1127',
};

export const unifyGreen = {
  50: '#D5F4E8',
  100: '#B9EDD9',
  200: '#96E5C6',
  300: '#73DCB2',
  400: '#50D39F',
  500: '#2DCA8C',
  600: '#26A875',
  700: '#1E875D',
  800: '#176546',
  900: '#0F432F',
  950: '#09281C',
};

export const unifyYellow = {
  50: '#FFF3E2',
  100: '#FFEBCF',
  200: '#FFE2B8',
  300: '#FFD8A0',
  400: '#FFCE88',
  500: '#FFC470',
  600: '#E9A749',
  700: '#CF8926',
  800: '#A46813',
  900: '#744707',
  950: '#492B00',
};

export const unifyBlueGrey = {
  100: '#c4d2de',
  200: '#92a9b9',
  300: '#587487',
  400: '#335468',
  500: '#253c4e',
};

export const unifyGrey = {
  50: '#FAFAFA',
  100: '#F5F5F5',
  200: '#E5E5E5',
  300: '#D4D4D4',
  400: '#A3A3A3',
  500: '#737373',
  600: '#525252',
  700: '#404040',
  800: '#262626',
  900: '#171717',
  950: '#0A0A0A',
};

// Severity color presets for consistent theming across components
export const severityColors = {
  success: {
    light: unifyGrey[100],    // Light grey background
    medium: unifyGreen[700],   // Medium green for icons
    dark: unifyGreen[500],     // Dark green for text/borders
  },
  info: {
    light: unifyTeal[50],  // Light teal background
    medium: unifyTeal[700], // Medium teal for icons
    dark: unifyTeal[500],   // Dark teal for text/borders
  },
  warn: {
    light: unifyYellow[50],   // Light yellow background
    medium: unifyYellow[700],  // Medium yellow for icons
    dark: unifyYellow[500],    // Dark yellow for text/borders
  },
  danger: {
    light: unifyRed[50],      // Light red background
    medium: unifyRed[700],     // Medium red for icons
    dark: unifyRed[500],       // Dark red for text/borders
  },
  primary: {
    light: unifyTeal[100], // Light teal background
    medium: unifyTeal[300], // Medium teal for icons
    dark: unifyTeal[500],  // Dark teal for text/borders
  },
  secondary: {
    light: unifyGrey[100],     // Light grey background
    medium: unifyGrey[300],    // Medium grey for icons
    dark: unifyGrey[500],      // Dark grey for text/borders
  },
};